import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';
import { workspacesAPI } from '../services/api';

const WorkspaceAccept = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [status, setStatus] = useState('working'); // working | success | error
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (!token) { setStatus('error'); setMessage('This invitation link is invalid.'); return; }
    (async () => {
      const r = await workspacesAPI.accept(token);
      if (r.success) { setStatus('success'); setMessage('You have joined the workspace.'); setTimeout(() => navigate('/workspaces'), 1800); }
      else { setStatus('error'); setMessage(r.message || 'This invitation is invalid or already used.'); }
    })();
  }, [token, navigate]);

  return (
    <div className="max-w-md mx-auto py-16 text-center">
      {status === 'working' && (<><Loader2 className="mx-auto h-12 w-12 text-brand-500 animate-spin" /><h1 className="mt-6 text-2xl font-bold text-ink-900">Joining workspace…</h1></>)}
      {status === 'success' && (<><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-500" /><h1 className="mt-6 text-2xl font-bold text-ink-900">Welcome aboard</h1><p className="mt-2 text-sm text-ink-500">{message}</p></>)}
      {status === 'error' && (<><XCircle className="mx-auto h-12 w-12 text-rose-500" /><h1 className="mt-6 text-2xl font-bold text-ink-900">Couldn't join</h1><p className="mt-2 text-sm text-ink-500">{message}</p><Link to="/workspaces" className="mt-5 inline-block text-sm font-medium text-brand-600">Go to workspaces</Link></>)}
    </div>
  );
};

export default WorkspaceAccept;
